import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import InquiryContext from "@/utils/inquiry-context";
import { XMarkIcon } from "@heroicons/react/20/solid";
import CloseButton from "../common/close-button";

const EditProduct = ({ open, setOpen, product, showName = false }) => {
  // const { products } = React.useContext(InquiryContext);
  // const [savedNotification, setSavedNotification] = React.useState(false);

  // React.useEffect(() => {
  //   setSavedNotification(true);
  //   const timeout = setTimeout(() => {
  //     setSavedNotification(false);
  //   }, 1000);
  //   return () => clearTimeout(timeout);
  // }, [products]);

  return (
    <Transition appear show={open} as={React.Fragment}>
      <Dialog
        onClose={() => setOpen(false)}
        as="div"
        className="relative z-modal-backdrop"
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50 dark-theme:bg-black/70" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="card container max-h-[80vh] w-auto transform overflow-x-hidden text-left align-middle transition-all dark-theme:border dark-theme:border-auto-black/30">
                <div className="flex border-b border-auto-black/30 p-6">
                  <div className="grow text-2xl font-bold text-primary-800">
                    {showName && product ? product.name : "Edit Product"}
                  </div>
                  <CloseButton onClick={() => setOpen(false)} />
                </div>
                <div className="flex w-full flex-col gap-4 overflow-y-scroll p-6">
                  {product &&
                    product.options.map((option) => (
                      <div
                        key={option.title}
                        className="flex w-full flex-col gap-4 py-4"
                      >
                        <div className="text-xl font-semibold text-auto-black/80">
                          {option.title}
                        </div>
                        <div className="inline-flex w-full flex-row flex-wrap items-start justify-start gap-2">
                          {option.values.map((value) => (
                            <OptionButton
                              title={option.title}
                              productCode={product.code}
                              value={value}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                </div>
                <div className="flex w-full items-center justify-between gap-4 border-t border-auto-black/30 px-6 py-4">
                  <div className="flex-grow text-sm font-semibold text-auto-black/80">
                    Changes are saved automatically.
                  </div>
                  <div
                    className="button"
                    type="button"
                    onClick={() => setOpen(false)}
                  >
                    Done
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default EditProduct;

const OptionButton = ({ productCode, title, value }) => {
  const { products, setProducts } = React.useContext(InquiryContext);
  const selected = React.useMemo(
    () =>
      products
        .find((p) => p.code === productCode)
        .options[title]?.includes(value)
        ? true
        : false,
    [products],
  );
  const toggleOption = () => {
    const productIndex = products.findIndex((p) => p.code === productCode);
    const newProducts = [...products];
    // if the title is not in the options, add it, otherwise, toggle the value
    newProducts[productIndex] = {
      ...newProducts[productIndex],
      options: {
        ...newProducts[productIndex].options,
        [title]: selected
          ? newProducts[productIndex].options[title].filter((v) => v !== value)
          : (() => {
              try {
                return newProducts[productIndex].options[title].concat(value);
              } catch (e) {
                return [value];
              }
            })(),
      },
    };
    // if the title is now empty, remove the empty title
    if (newProducts[productIndex].options[title].length === 0) {
      delete newProducts[productIndex].options[title];
    }
    setProducts(newProducts);
  };

  return (
    <button
      className={`${selected ? "option-button-on" : "option-button-off"} `}
      onClick={toggleOption}
    >
      {value}
    </button>
  );
};
